// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"786e025d","787":"9a6a1170"}[chunkId] + ".chunk.js";
};